module.exports = __webpack_public_path__ + "media/stylesheets/images/recruit-2ae99fe340059a84f08460ace8e2b9ca.jpg";